module.exports = __webpack_public_path__ + "img/gps_and_samsung.2694d854.jpg";